import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import NavbarSection from "../components/NavbarSection";
import FooterSection from "../components/FooterSection";

const Terms = () => {
  return (
    <>
      {/* Navbar without vector background */}
      <div style={{ 
        backgroundColor: "#f0f0f0",
        paddingBottom: "20px" 
      }}>
        <NavbarSection  />
      </div>

      {/* Terms Section */}
      <div style={{ 
        backgroundColor: "#f0f0f0", 
        minHeight: "100vh",
        padding: "80px 0"
      }}>
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Row className="justify-content-center">
              <Col lg={10}>
                {/* Header */}
                <h1 style={{ 
                  fontSize: "3.5rem", 
                  fontWeight: "700",
                  color: "#1a1a2e",
                  marginBottom: "1rem",
                  lineHeight: "1.2"
                }}>
                  TERMS OF USE
                </h1>
                
                <p style={{ 
                  fontSize: "1rem", 
                  color: "#666",
                  marginBottom: "3rem"
                }}>
                  Last updated: December 2025
                </p>

                {/* 1. Overview */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    1. OVERVIEW OF THE SERVICE
                  </h2>
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    WriteOffGenie helps business owners identify, track, and organize potential tax deductions and generate IRS-ready documentation based on the information users provide. WriteOffGenie is not a tax, financial, or legal advisor. All tax filing decisions and classifications must be reviewed by a qualified professional.
                  </p>
                </section>

                {/* 2. Eligibility */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    2. ELIGIBILITY
                  </h2>
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    You must be at least 18 years old, provide accurate information, and use the Service only for lawful purposes.
                  </p>
                </section>

                {/* 3. Account Registration */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    3. ACCOUNT REGISTRATION & SECURITY
                  </h2>
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    You are responsible for maintaining the confidentiality of your account credentials and all activity under your account.
                  </p>
                </section>

                {/* 4. Subscription & Billing */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    4. SUBSCRIPTION & BILLING
                  </h2>
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7", marginBottom: "1.5rem" }}>
                    WriteOffGenie offers auto-renewing subscription plans billed monthly or yearly. Subscriptions renew automatically unless canceled. Payments are processed by Apple App Store or Google Play Store. Refunds must be requested through Apple or Google directly.
                  </p>

                  <h3 style={{ fontSize: "1.3rem", fontWeight: "600", color: "#1a1a2e", marginBottom: "1rem" }}>
                    4.1 Auto-Renewal & Cancellation
                  </h3>
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    Your subscription will continue to renew automatically until canceled. Users may manage or cancel their subscriptions at any time through their Apple ID or Google Play account settings. Deleting the app does not cancel an active subscription.
                  </p>
                </section>

                {/* 5. Use of Service */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    5. USE OF THE SERVICE
                  </h2>
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    You may not misuse, disrupt, reverse-engineer, or interfere with the Service.
                  </p>
                </section>

                {/* 6. Deduction Identification */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    6. DEDUCTION IDENTIFICATION & DOCUMENTATION
                  </h2>
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    WriteOffGenie provides suggestions and auto-categorization, but eligibility for deductions is not guaranteed. Users must verify all information before tax use.
                  </p>
                </section>

                {/* 7. Banking Connections */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    7. BANKING CONNECTIONS (PLAID)
                  </h2>
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    WriteOffGenie uses Plaid to securely connect financial accounts. Banking credentials are never stored by WriteOffGenie.
                  </p>
                </section>

                {/* 8. AI Generated Content */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    8. AI-GENERATED CONTENT
                  </h2>
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    AI may generate deduction descriptions or summaries. Users must review all generated content for accuracy before relying on it for tax or business purposes.
                  </p>
                </section>

                {/* 9. Privacy */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    9. PRIVACY
                  </h2>
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    Your use of the Service is governed by our Privacy Policy:{" "}
                    <a href="https://writeoffgenie.ai/privacy-policy" style={{ color: "#08a040ff", textDecoration: "none" }}>
                      https://writeoffgenie.ai/privacy-policy
                    </a>
                  </p>
                </section>

                {/* 10. Intellectual Property */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    10. INTELLECTUAL PROPERTY
                  </h2>
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    All intellectual property related to the Service is owned by WriteOffGenie and may not be copied, reproduced, or redistributed without permission.
                  </p>
                </section>

                {/* 11. Termination */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    11. TERMINATION
                  </h2>
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    We may suspend or terminate access for violations, fraudulent activity, or if required by law.
                  </p>
                </section>

                {/* 12. Disclaimers */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    12. DISCLAIMERS
                  </h2>
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    The Service is provided 'as-is' without guarantees. We do not guarantee tax savings, deduction eligibility, or accuracy of documentation.
                  </p>
                </section>

                {/* 13. Limitation of Liability */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    13. LIMITATION OF LIABILITY
                  </h2>
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    WriteOffGenie is not liable for tax penalties, missed deductions, audit outcomes, inaccurate data, or business losses. Liability is limited to the amount paid in the prior 12 months.
                  </p>
                </section>

                {/* 14. Indemnification */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    14. INDEMNIFICATION
                  </h2>
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    Users agree to indemnify and hold WriteOffGenie harmless from claims arising from misuse, incorrect data, or violations of these Terms.
                  </p>
                </section>

                {/* 15. Governing Law */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    15. GOVERNING LAW
                  </h2>
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    These Terms are governed by the laws of North Carolina, USA.
                  </p>
                </section>

                {/* 16. Changes */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    16. CHANGES TO THESE TERMS
                  </h2>
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    We may update these Terms periodically. Continued use constitutes acceptance.
                  </p>
                </section>

                {/* 17. Contact Us */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    17. CONTACT US
                  </h2>
                  
                  <address style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7", fontStyle: "normal" }}>
                    <strong>Swecha LLC (DBA WriteOffGenie)</strong><br />
                    Apex, North Carolina, USA<br />
                    Email: <a href="mailto:support@writeoffgenie.ai" style={{ color: "#08a040ff", textDecoration: "none" }}>support@writeoffgenie.ai</a>
                  </address>
                </section>

              </Col>
            </Row>
          </motion.div>
        </Container>
      </div>

      <FooterSection />
    </>
  );
};

export default Terms;